export default {
	KOLProducts(state){
		return state.KOLProducts;
	},
	KOLPackages(state){
		return state.KOLPackages;
	},
	getCopyData(state){
		return state.copyData;
	}
}



// WEBPACK FOOTER //
// ./src/Shop/store/getters.js